import React from 'react';

import styles from './HGroup.module.css';

export const HGroup: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <hgroup className={styles.hgroup}>{children}</hgroup>;
};
